import React, { useMemo } from "react";

import { useIntl } from "react-intl";

import PageMeta from "Components/PageMeta";
import { capitalize } from "Libs/utils";
import { useCurrentService } from "Reducers/environment/hooks/useCurrentService";
import { useCurrentWorker } from "Reducers/environment/hooks/useCurrentWorker";

import AppOverview from "./AppOverview";
import RouterOverview from "./RouterOverview";
import * as S from "./ServiceOverview.styles";
import ServiceOverviewDetails from "./ServiceOverviewDetails";
import WorkerOverview from "./WorkerOverview/WorkerOverview";

const ServiceOverview = () => {
  const currentService = useCurrentService();
  const currentWorker = useCurrentWorker();
  const intl = useIntl();

  const selectedOverview = useMemo(() => {
    if (currentWorker) {
      return <WorkerOverview />;
    }
    if (!currentService) return null;

    switch (currentService.class) {
      case "app":
        return <AppOverview />;
      case "service":
        return <ServiceOverviewDetails />;
    }

    return <RouterOverview />;
  }, [currentService, currentWorker]);

  return (
    <S.Wrapper>
      <PageMeta title={capitalize(intl.formatMessage({ id: "services" }))} />
      {selectedOverview}
    </S.Wrapper>
  );
};

export default ServiceOverview;
